import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Badge} from 'reactstrap';

import conf from '../../../../../shared/conf.js';
import Labels from '../Labels/Labels.jsx';
import Price from '../Price/Price.jsx';
import Availability from '../Availability/Availability.jsx';
import Picture from '../../../Picture/Picture.jsx';

import './FreelanceSearchListItem.scss';

export default class FreelanceSearchListItem extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object,
    freelance: PropTypes.shape({
      user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        image: PropTypes.object,
      }),
      id: PropTypes.number.isRequired,
      tjm_min: PropTypes.number,
      tjm_max: PropTypes.number,
      availability: PropTypes.string,
    }).isRequired,
    isAdmin: PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),

  };

  static defaultProps = {
    currentUser: null,
    isAdmin: false,
  }

  render() {
    const {currentUser, freelance, link, isAdmin, score} = this.props;
    const user = freelance.user;
    const trimmedFullname = (user?.fullname ?? '').trim();
    const isOwner = currentUser && user.id === currentUser.id;

    const currentUserCanView = currentUser ?
      (isAdmin || currentUser.account_type !== conf.accountTypes.freelance || isOwner) :
      false
    ;

    const image = currentUserCanView ? user?.image?.thumbnail ?? null : null;
    const altImage = currentUser ? trimmedFullname : 'Vous devez être connecté pour voir la photo des consultants';

    return (
      <li className="col-md-12 freelance-search-list-item p-2">
        <Link to={link}>
          <div className="d-flex align-items-center flex-column flex-lg-row justify-content-between">
            <div className="d-flex align-items-center flex-column flex-lg-row">
              <div className="avatar">
                <Picture
                  round={false}
                  src={image}
                  alt={altImage}
                  className="picture"/>
              </div>
              <h6 className="name mx-lg-1">{trimmedFullname === '' ? '???' : trimmedFullname}</h6>
              <p className="text-center mx-lg-1">{freelance.title}</p>
              <div className="d-flex flex-column flex-lg-row align-items-center">
                <div className="d-flex">
                  <div className="availability mx-1"><Availability freelance={freelance}/></div>
                  <div className="tjm mx-1">
                    <Price freelance={freelance}/>
                  </div>
                </div>
                {isAdmin ?
                  <div className="d-flex align-items-center justify-content-around">
                    <Badge color="light">FL #{freelance?.id ?? 'N/A'}</Badge>&nbsp;
                    <Badge color="light">User #{freelance?.user.id ?? 'N/A'}</Badge>
                  </div> : ''
                }
              </div>
            </div>
            <div className="d-flex align-items-center">
              <Labels className="mx-1" user={user} freelance={freelance}/>
              {score ? <Badge color="light">Score: {Math.round(score)}</Badge> : ''}
            </div>
          </div>
        </Link>
      </li>
    );
  }
}
